import * as React from "react";
import { styled, alpha } from "@mui/material/styles";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { IconButton } from "@mui/material";
import { MoreVert } from "@mui/icons-material";
import ConfirmationDialog from "../dialogs/ConfirmationDialog";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

export default function ActionsMenu({ row, actions = [], getData }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const [deleteEntity, setDeleteEntity] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAction = (action) => {
    if (action.title === "Delete" || action.type === "Delete") {
      setDeleteEntity(row);
      handleClose();
      return;
    }
    action.action(row, getData);
    handleClose();
  };

  const isDisabled = (action) => {
    if (typeof action.disabled === "function") {
      return action.disabled(row);
    }

    return Boolean(action.disabled);
  };

  return (
    <div>
      <IconButton
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        disabled={!actions?.length}
      >
        <MoreVert />
      </IconButton>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {(actions || []).map((action) => (
          <MenuItem
            key={action.title}
            onClick={() => handleAction(action)}
            disableRipple
            disabled={isDisabled(action)}
          >
            {action.icon}
            {action.title}
          </MenuItem>
        ))}
      </StyledMenu>
      <ConfirmationDialog
        onCancel={() => setDeleteEntity(null)}
        onConfirm={async () => {
          const deleteAction = actions.find(
            (action) => action.title === "Delete"
          )?.action;
          const res = await deleteAction(deleteEntity, getData);
          if (res) {
            setDeleteEntity(null);
          }
        }}
        open={Boolean(deleteEntity)}
      />
    </div>
  );
}
